type LeadRow = {
  id: string;
  patientName: string;
  phone: string;
  status: string;
  leadSubStatus?: string | null;
  assignedTo?: { name: string } | null;
  partnerPointsLedger?: Array<{ milestone: string; points: number; status?: string }>;
  referralPartner?: { firstName: string; lastName: string } | null;
};

type Props = {
  leads: LeadRow[];
  showPartnerColumn?: boolean;
  emptyMessage?: string;
};

export default function PartnerLeadsTable({
  leads,
  showPartnerColumn,
  emptyMessage = 'No leads found',
}: Props) {
  return (
    <div className="rounded-lg border overflow-hidden bg-white">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 text-left">
          <tr>
            <th className="px-4 py-2">Patient</th>
            <th className="px-4 py-2">Phone</th>
            {showPartnerColumn && <th className="px-4 py-2">Partner</th>}
            <th className="px-4 py-2">Status</th>
            <th className="px-4 py-2">Assigned to</th>
            <th className="px-4 py-2">Points</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {leads.map((l) => (
            <tr key={l.id}>
              <td className="px-4 py-2">
                <div className="font-medium">{l.patientName}</div>
                <div className="text-xs text-gray-500">{l.id}</div>
              </td>
              <td className="px-4 py-2">{l.phone}</td>
              {showPartnerColumn && (
                <td className="px-4 py-2">
                  {l.referralPartner
                    ? `${l.referralPartner.firstName} ${l.referralPartner.lastName}`
                    : '—'}
                </td>
              )}
              <td className="px-4 py-2">
                <div>{l.status}</div>
                <div className="text-xs text-gray-500">{l.leadSubStatus || '—'}</div>
              </td>
              <td className="px-4 py-2">{l.assignedTo?.name || '—'}</td>
              <td className="px-4 py-2">
                {(l.partnerPointsLedger ?? [])
                  .map((x) => `${x.milestone}:${x.points}`)
                  .join(', ') || '—'}
              </td>
            </tr>
          ))}
          {leads.length === 0 && (
            <tr>
              <td className="px-4 py-6 text-center text-gray-500" colSpan={showPartnerColumn ? 6 : 5}>
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
